module.exports = __webpack_public_path__ + "media/images/prismic_catalog/presentation_cards/categories/haircut-3f2c84fb98b4d8cecaea9a5acf6e6bf5.png";